import React from "react";
import ReactDocumentTitle from "~/components/ReactDocumentTitle";
import UILink from "~/old-ui/UILink";
import {reverse} from "~/urls";
import {backendUrl, buildQueryString} from "~/utils";
import UINotification from "~/old-ui/UINotification";

export default function DevIndexScene() {

  const [backendStatus, setBackendStatus] = React.useState({
    status: 'PENDING',
    lastCheck: Date.now(),
  });

  const recheckBackend = React.useCallback(() => {
    setBackendStatus({
      status: 'PENDING',
      lastCheck: Date.now()
    })
  }, [setBackendStatus]);

  React.useEffect(() => {
    fetch(backendUrl('/graphql'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify({
        'query': '{__schema{__typename}}'
      }),
    }).then(() => {
      setBackendStatus({
        status: 'OK',
        lastCheck: backendStatus.lastCheck
      })
    }).catch((err) => {
      setBackendStatus({
        status: 'ERROR',
        error: err,
        lastCheck: backendStatus.lastCheck
      });
      console.log('fetch failed with error', err);
    });
  }, [backendStatus.lastCheck, setBackendStatus]);

  return (
    <>
      <ReactDocumentTitle title='Index'/>

      <div style={{padding: "12px 20px"}}>
        {backendStatus.status === 'OK' && (
          <UINotification
            success
            title='Backend OK'
          />
        )}
        {backendStatus.status === 'ERROR' && (
          <UINotification
            danger
            title='Backend test failed'
            text={backendStatus.error.toString()}
          />
        )}

        <h3>Settings</h3>

        <ul>
          <li><UILink href='/bundle-report.html'>Bundle report</UILink></li>
          <li><UILink href='/topbar.html'>Topbar test page</UILink></li>
          <li><UILink href='/index.html'>Index page</UILink></li>
          <li><UILink href='#' onClick={recheckBackend}>Retest backend</UILink></li>

          <li><UILink href={reverse('dev:settings')}>Settings</UILink></li>
        </ul>

        {}
      </div>
    </>
  )
}
